import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import InputComp from "./InputComp";
import DropDownComp from "./DropDownComp";
import { useDispatch, useSelector } from "react-redux";

const DepartmentModalComp = (props) => {
  const [division, setDivision] = useState(
    props?.rowDataUser?.division && props?.rowDataUser?.division
      ? {
          value: props?.rowDataUser?.division.division_id,
          label: props?.rowDataUser?.division.divisionName,
        }
      : ""
  );
  const [divisionArr, setDivisionArr] = useState();
  const rowDataDivision = useSelector(
    (state) => state.division.getDivisionData
  );

  useEffect(() => {
    if (rowDataDivision && rowDataDivision?.length > 0) {
      var data = [];
      for (var i = 0; i < rowDataDivision.length; i++) {
        data.push({
          label: rowDataDivision[i].divisionName,
          value: rowDataDivision[i].division_id,
          division_id: rowDataDivision[i].division_id,
        });
      }
      setDivisionArr(data);
    }
  }, []);

  const [departmentName, setDepartmentName] = useState(
    props.rowDataUser && props.rowDataUser.departmentName
      ? props.rowDataUser.departmentName
      : ""
  );

  return (
    <Modal
      size="lg"
      show={props.isShow}
      onHide={props.handleClose}
      backdrop="static"
      centered
      keyboard={false}
    >
      <Modal.Header style={{ backgroundColor: "rgb(0, 42, 74)" }}>
        <Modal.Title style={{ fontFamily: "Roboto", color: "white" }}>
          {props.title ? props.title : "Add Department"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div
          className="row container"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "space-between",
          }}
        >
          <div className="row container mt-4 d-flex f-direction-row ">
            <div className="col-12 col-lg-4 col-md-4 col-sm-12">
              <label style={{ fontSize: 16 }}>{"Department Name"}</label>
            </div>
            <div className="col-12 col-lg-6 col-md-6 col-sm-12">
              <InputComp
                style={{
                  display: "flex",
                  flexDirection: "row",
                  borderColor: "hsl(0, 0%, 50%)",
                  borderStyle: "solid",
                  borderWidth: "1px",
                  padding: "4px",
                  fontSize: 14,
                }}
                labelName={"Department Name"}
                maxLength={30}
                placeholder={"Department Name"}
                value={departmentName}
                onChangeHandler={(departmentName) => {
                  setDepartmentName(departmentName);
                }}
              />
            </div>
          </div>
          <div className="row container mt-4 d-flex f-direction-row ">
            <div className="col-12 col-lg-4 col-md-4 col-sm-12">
              <label style={{ fontSize: 16 }}>{"Choose Division22"}</label>
            </div>
            <div className="col-4 col-sm-4 col-md-4 col-lg-4">
              <DropDownComp
                styles={{
                  display: "flex",
                  flexDirection: "row",
                  fontSize: 14,

                  width: "100%",
                  height: 35,
                  padding: 2,
                  borderColor: "hsl(0, 0%, 50%)",
                  borderRadius: "4px",
                  borderStyle: "solid",
                  borderWidth: "1px",
                }}
                name={"Choose Division"}
                options={divisionArr}
                onChange={(value) => {
                  setDivision(value);
                }}
                value={division}
              />
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <div
          className="row col-12 col-sm-12 col-md-12 col-lg-12"
          style={{ display: "flex", justifyContent: "space-around" }}
        >
          <div className="col-12 col-sm-12 col-md-12 col-lg-6">
            <button
              onClick={() => {
                let departmentObj;
                if (departmentName == "") {
                  alert("Please Enter Department Name");
                } else if (division === "") {
                  alert("Please Select Division");
                } else {
                  if (props.rowDataUser != null && props.rowDataUser != "") {
                    departmentObj = {
                      departmentName: departmentName ? departmentName : "",
                      department_id: props.rowDataUser?.department_id,
                      is_active: props.is_active,
                      division_id: division?.division_id,
                    };
                  } else {
                    departmentObj = {
                      departmentName: departmentName ? departmentName : "",
                      division_id: division?.division_id,
                    };
                  }
                }
                console.log("departmentObj", departmentObj);
                props.setValue(departmentObj);
              }}
              style={{
                backgroundColor: "#002a4a",
                height: "80%",
                color: "white",
                width: "100%",
                borderRadius: 8,
                borderWidth: 1,
              }}
              className="btn btn-primary"
              variant="primary"
            >
              {props.rowDataUser != null ? "Edit Department" : "Add Department"}
            </button>
          </div>

          <div className="col-12 col-sm-12 col-md-12 col-lg-6">
            <button
              style={{
                backgroundColor: "#002a4a",
                height: "80%",
                color: "white",
                width: "100%",
                borderRadius: 8,
                borderWidth: 1,
              }}
              onClick={() => {
                props.show(false);
              }}
              className="btn btn-primary"
              variant="primary"
            >
              {"Cancel"}
            </button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
export default DepartmentModalComp;
